export function isOverflowingRight(
  element: HTMLElement,
  parentElement: HTMLElement | null
): boolean {
  if (!parentElement) {
    return false;
  }

  const offsetLeft = element.offsetLeft;
  const elementWidth = element.getBoundingClientRect().width;
  const scrollLeft = parentElement.scrollLeft;
  const scrollSnapWidth = parentElement.getBoundingClientRect().width;

  const positionInVisibleArea = offsetLeft + elementWidth - scrollLeft;
  return positionInVisibleArea > scrollSnapWidth;
}
